/* globals jQuery */
//https://swiperjs.com/
import Swiper, {Pagination, EffectFade, A11y, Autoplay} from 'swiper';

//MAIN HERO SLIDESHOW
const heroSwiper = new Swiper('.js-home-slideshow', {
    modules: [Pagination, EffectFade, A11y, Autoplay],
    effect: 'fade',
    loop: true,
    a11y: {
        enabled: true,
        containerMessage: 'Hero carousel',
        containerRoleDescriptionMessage: 'carousel',
        itemRoleDescriptionMessage: 'slide',
        firstSlideMessage: 'First slide',
        lastSlideMessage: 'Last slide',
        paginationBulletMessage: 'Go to slide {{index}}',
        prevSlideMessage: 'Previous slide',
        nextSlideMessage: 'Next slide',
    },
    autoplay:{
        delay: 8000, //8 seconds per slide
        disableOnInteraction: true,
        pauseOnMouseEnter: true
    },
    pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        hideOnclick: false,
        clickable: true,
        renderBullet: function (index, className) {
            // Use actual button elements instead of spans with role="button"
            // This ensures proper keyboard support (both Enter and Space) out of the box
            return '<button type="button" class="' + className + '" aria-label="Go to slide ' + (index + 1) + '"></button>';
        }
    },
    on: {
        init: function() {
            // Add additional ARIA attributes for better carousel accessibility
            enhanceCarouselAccessibility(this);
        }
    }
});

/**
 * Enhance carousel accessibility with proper ARIA attributes
 * @param {Object} swiper - Swiper instance
 */
function enhanceCarouselAccessibility(swiper) {
    if (!swiper || !swiper.el) return;
    
    const container = swiper.el;
    const wrapper = container.querySelector('.swiper-wrapper');
    
    // Set proper role and aria attributes on container
    container.setAttribute('role', 'region');
    container.setAttribute('aria-roledescription', 'carousel');
    container.setAttribute('aria-label', 'Hero slideshow');
    
    // Ensure wrapper has proper group role
    if (wrapper) {
        wrapper.setAttribute('role', 'group');
        wrapper.setAttribute('aria-live', 'polite');
        wrapper.setAttribute('aria-atomic', 'false');
    }
    
    // Add accessible names to each slide based on content
    const slides = container.querySelectorAll('.swiper-slide');
    slides.forEach((slide, index) => {
        slide.setAttribute('role', 'group');
        slide.setAttribute('aria-roledescription', 'slide');
        
        // Try to get a meaningful label from the slide content
        const heading = slide.querySelector('h2');
        const slideNumber = index + 1;
        const totalSlides = slides.length;
        
        if (heading && heading.textContent.trim()) {
            // Use heading text as the accessible name
            slide.setAttribute('aria-label', `Slide ${slideNumber} of ${totalSlides}: ${heading.textContent.trim()}`);
        } else {
            // Fallback to generic label
            slide.setAttribute('aria-label', `Slide ${slideNumber} of ${totalSlides}`);
        }
    });
}
